// @ts-check
const activeClass = "border-green-500";
const inactiveClass = "border-green-300";

const makeSideBarItemActive = () => {
    document.querySelectorAll(`li[data-question].${activeClass}`).forEach((el) => {
        el.classList.replace(activeClass, inactiveClass);
    });
    let activeItem = document.querySelector(`li[data-question='${location.href}']`);
    if (activeItem != undefined) {
        activeItem.classList.replace(inactiveClass, activeClass);
    }
};

document.addEventListener("DOMContentLoaded", makeSideBarItemActive);
window.addEventListener("hashchange", makeSideBarItemActive);